import React from 'react';
import PauseImg from '../../resources/images/icon Pause - CBA2A7.svg'

const PauseIcon = () => (
    <img src={PauseImg} style={{width: 35}}/>
);

export default PauseIcon;